import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import Avatar from '@base/Avatar/Avatar';
import imageHelper from '@utils/imageHelper';
import { LMPSessionStatus } from '@constants/index';
import pushRoute from '@utils/pushRoute';
import useGoalInfo from '@api/hooks/goal/useGoalInfo';

const SessionDetailCard = styled.div`
  width: 627px;
  display: flex;
  flex-direction: row;
  margin: ${Spacings.SPACING_6B} 0px;
`;
const SessionDetailCardHeading = styled.div`
  margin-left: ${Spacings.SPACING_6B};
  display: flex;
  justify-content: center;
  flex-direction: column;
`;
const SessionDetailCardLargeHeading = styled.div`
  max-width: 500px;
  font-weight: 600;
  font-size: 14px;
  color: var(--color-base-fill);
  margin: 0px 0px;

  ${({ faded }) =>
    faded &&
    `
    color: var(--color-text-secondary);
    line-height: 20px;
  `}

  ${({ recording }) =>
    recording &&
    `
  font-weight: normal;
  `}
`;

const SessionDetailCardSmallHeading = styled.span`
  max-width: 500px;
  font-size: ${Spacings.SPACING_3B};
  line-height: 18px;
  color: var(--color-text-secondary);
  margin: ${Spacings.BASE}px 0px;
`;

const SessionDetailsCard = ({
  cardDetails,
  sessionState,
  goalUID,
  sessionUID
}) => {
  const { goalInfo = {} } = useGoalInfo(goalUID);
  if (!cardDetails) return null;
  let cardUpdatedImage;
  if (cardDetails.cardImage?.endsWith('.svg')) {
    cardUpdatedImage = imageHelper.getImage(cardDetails.cardImage);
  } else {
    cardUpdatedImage = cardDetails.cardImage;
  }
  const { slug } = goalInfo;

  const playSession = () => {
    if (sessionState === LMPSessionStatus.RECORDING_AVAILABLE) {
      pushRoute(
        '/goal/[goalSlug]/[goalUID]/one-to-one-livementorship/attending-session/[sessionUID]',
        `/goal/${slug}/${goalUID}/one-to-one-livementorship/attending-session/${sessionUID}`
      );
    }
  };
  return (
    <SessionDetailCard>
      {cardDetails?.cardImage ? (
        <Avatar
          src={cardUpdatedImage}
          alt="session-card1"
          size={Spacings.SPACING_10B}
          circular
          onClick={playSession}
        />
      ) : null}
      <SessionDetailCardHeading>
        <SessionDetailCardLargeHeading
          faded={cardDetails.faded}
          recording={cardDetails?.largeHeading.includes('recording')}
        >
          {cardDetails?.largeHeading}
        </SessionDetailCardLargeHeading>
        <SessionDetailCardSmallHeading faded={cardDetails.faded}>
          {cardDetails?.smallHeading}
        </SessionDetailCardSmallHeading>
      </SessionDetailCardHeading>
    </SessionDetailCard>
  );
};

export default SessionDetailsCard;
